export default __webpack_public_path__ + "static/media/ar.ccda4e2d.png";